// src/components/ui/LawyerReferralCard.tsx
import React from 'react';

interface Props {
  variant: 'subtle' | 'prominent';
  jurisdiction?: string | null;
  category?: string | null;
  onTrackClick?: () => void;
}

const CATEGORY_LABELS: Record<string, string> = {
  criminal: 'criminal defense', family: 'family law', immigration: 'immigration',
  safety: 'domestic violence', injury: 'personal injury', financial: 'bankruptcy',
  employment: 'employment law', litigation: 'litigation', estate: 'estate law',
};

export function LawyerReferralCard({ variant, jurisdiction, category, onTrackClick }: Props) {
  const avvoUrl = `https://www.avvo.com/find-a-lawyer${jurisdiction ? `?loc=${jurisdiction}` : ''}`;
  const practiceArea = category ? CATEGORY_LABELS[category] : undefined;

  const handleClick = () => {
    onTrackClick?.();
    window.open(avvoUrl, '_blank', 'noopener,noreferrer');
  };

  if (variant === 'subtle') {
    return (
      <div className="mt-1 flex justify-end">
        <button
          onClick={handleClick}
          className="text-xs text-gray-400 hover:text-amber-600 transition-colors"
        >
          Need a real lawyer? →
        </button>
      </div>
    );
  }

  return (
    <div className="mt-3 rounded-lg border border-blue-200 bg-blue-50 p-3 flex items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="text-sm font-medium text-blue-800">
          🏛️ This may require professional legal help
        </p>
        <p className="text-xs text-blue-600 mt-0.5">
          Find a {practiceArea ?? 'qualified'} attorney
          {jurisdiction ? ` in ${jurisdiction}` : ' near you'} for free consultations.
        </p>
      </div>
      <button
        onClick={handleClick}
        className="flex-shrink-0 text-xs bg-blue-600 text-white rounded-lg px-3 py-1.5 hover:bg-blue-700 transition-colors font-medium whitespace-nowrap"
      >
        Find a Lawyer
      </button>
    </div>
  );
}
